import React, { ElementType, FC } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { SegmentedControlOptionProps } from '@column/column-ui-kit';

interface Entry extends Partial<SegmentedControlOptionProps> {
  path: string;
  hide?: boolean;
  activePath?: string;
}

interface CustomPageProps {
  entries?: Entry[];
  element: ElementType;
}

export type CustomPageContext = { entries?: Entry[] };

const PageWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const Page: FC<CustomPageProps> = ({ element, entries }) => {
  return <PageWrapper>{React.createElement(element, { entries }, <Outlet />)}</PageWrapper>;
};
